module.exports = __webpack_public_path__ + "static/header-logo-a779f82fdde246c6ec69913b0cb63172.png";